module.exports = __webpack_public_path__ + "img/play-store.824468a0.png";